import template from './communication-tool-list.template.html';
import controller from './communication-tool-list.controller';
import './communication-tool-list.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool-list/communication-tool-list.component.js